import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function Faq() {
  return (
    <div>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>What is BSC Name Service ?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            BNS is an Binance Smartchain token that governs the BSC Name Service, a protocol for human-readable crypto addresses and decentralized domain names.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography>How to Buy Domain .BEAN ?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            So how do you go about buying an BNS domain? At the point where domains are unique, meaning that no two Joes can simultaneously have total control over joe.bean, BNS domains are registered on a time basis, with ownership of the domain being transferred via an NFT. Crucially, the latter detail means that BNS domains can technically be bought on the secondary market, but this practice is relatively uncommon.
          </Typography>
          <List>
            <ListItem>
            <ListItemText>
            Send BNB BEB20 to Metamask, In order to register your domain, you need to send your BNB to your MetaMask wallet, which is done using your wallet’s underlying BEB20 address (of the form “0x” followed by 40 hexadecimal digits (0-9 and a-f)). MetaMask can copy your address to your computer’s clipboard through the account header in the top center of the extension window. This data can then be pasted into the transfer destination address field of the exchange that you used to purchase your BNB.
            </ListItemText>
            </ListItem>
            <ListItem>
            <ListItemText>
            Connect your wallet to BNS Domains, Once your wallet has BNB, you can navigate to the BNS dApp, where you can connect your wallet to the site by pressing the “Connect” button. This action will prompt a MetaMask (or other wallet if you’re not using MetaMask) popup with further instructions on how to authorize the connection. Once you follow the steps outlined in your wallet, then your wallet is connected to the dApp and can now be used to transfer BNB in order to make a purchase.
            </ListItemText>
            </ListItem>
            <ListItem>
            <ListItemText>
            Choose an BNS Domain and make your purchase, Once on the BNS dApp page, you can use the search bar to see if your desired domain is available for registration, and its current owner and the expiration of its current registration if it is already registered. When purchasing an unused domain, three-character .bean names are around $13,57 in BNB per year, four-character .bean names are around $8,71 in BNB per year, and Five-plus-character .bean names are around $2,71 per year. This registration cost doesn’t factor in gas prices, so registering qeod.bean currently costs about $8,17 for 1 year (0.03 BNB * 1 year + 0.047 BNB gas fee), and about $16,34 for 2 years (0.06 BNB *2 years + 0.047 ETH gas fee) and so on, while registering aadharsh.bean currently would cost ~$2 for 1 year (0.002 BNB * 1 year + 0.0042 BNB gas fee), and ~$4 for 2 years (0.002 BNB* 2 years + 0.0042 BNB gas fee). 
            </ListItemText>
            </ListItem>
          </List>
         <Typography>
            Note that the gas fee is the vast majority of the cost associated with the shorter domain.
         </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3a-content"
          id="panel3a-header"
        >
          <Typography>How to Sell Domain NFT ?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            To sell a BNS Domain, you can sell it as an NFT in a marketplace that supports the Binance Smartchain network.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
